import React from "react"
import { linkify } from "../utils/utils"

import styles from "../styles/twitter-block.module.scss"

import TwitterIcon from "../images/twitter-circle-icon.svg"

const TwitterBlock = ({ tweet }) => {
  return (
    <div className={styles.mainContainer}>
      <div>
        <img
          className={styles.twitterIcon}
          src={TwitterIcon}
          alt="twitter icon"
        />
        <h3>Follow us on Twitter</h3>
        <a
          className={styles.handleLink}
          href="https://twitter.com/vastconference?lang=en"
          target="_blank"
        >
          @vastconference
        </a>
      </div>
      <div
        className={styles.tweetContainer}
        dangerouslySetInnerHTML={{ __html: linkify(tweet.full_text) }}
      />
      <p className={styles.tweetDate}>
        {tweet.created_at
          .split(" ")
          .slice(0, 3)
          .join(" ")}
      </p>
    </div>
  )
}

export default TwitterBlock
